import Inventory from 'locales/dental/th/warehouses/inventory.json'
import Adjustment from 'locales/dental/th/warehouses/adjustment.json'
import medicine from 'locales/dental/th/warehouses/medicine.json'
import product from 'locales/dental/th/warehouses/product.json'
import importProduct from 'locales/dental/th/warehouses/import-product.json'

const Warehouses = {
  ...Inventory,
  ...Adjustment,
  ...medicine,
  ...product,
  ...importProduct
}

export default Warehouses
